(function(){
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches:false };
  var reduce = mq.matches;
  var lenis = null;
  var pw = document.querySelector('.page-wrapper');
  function useWrapper(){ if (!pw) return false; var s = getComputedStyle(pw); return /(auto|scroll)/.test(s.overflowY) && pw.scrollHeight > pw.clientHeight + 2; }
  var scroller = window;
  function getY(){ return scroller === window ? window.scrollY : scroller.scrollTop; }

  /* ---------- smooth scroll (Lenis, desktop pointers only) ---------- */
  function smooth(){
    if (reduce || !window.Lenis || !window.matchMedia('(pointer:fine)').matches) return;
    var opts = scroller === window ? {} : { wrapper: pw, content: pw, eventsTarget: pw };
    lenis = new window.Lenis(Object.assign(opts, { duration: 1.15, easing: function(t){ return Math.min(1, 1.001 - Math.pow(2, -10 * t)); }, smoothWheel: true }));
    function raf(t){
      var locked = document.documentElement.hasAttribute('scroll-lock') || document.body.style.overflow === 'hidden' || document.documentElement.style.overflow === 'hidden' || document.documentElement.hasAttribute('scroll-lock') || document.body.hasAttribute('scroll-lock') || document.querySelector('dialog[open], .menu-drawer-container[open], details[open] > .menu-drawer');
      if (locked && !lenis.isStopped) lenis.stop(); else if (!locked && lenis.isStopped) lenis.start();
      lenis.raf(t); requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
    document.addEventListener('click', function(e){
      var a = e.target.closest('a[href*="#"]'); if (!a) return;
      var url = new URL(a.href, location.href); if (url.pathname !== location.pathname || !url.hash) return;
      var el = document.getElementById(decodeURIComponent(url.hash.slice(1))); if (!el) return;
      e.preventDefault(); history.pushState(null, '', url.hash); window.dispatchEvent(new HashChangeEvent('hashchange'));
      lenis.scrollTo(el, { offset: -90, duration: 1.4 });
    });
  }

  /* ---------- split headlines into lines ---------- */
  function splitLines(root){
    (root||document).querySelectorAll('[data-si-lines]:not([data-split])').forEach(function(el){
      el.setAttribute('data-split','1');
      var text = el.textContent.trim(); if (!text) return;
      el.setAttribute('aria-label', text);
      var words = text.split(/\s+/);
      el.innerHTML = words.map(function(w){ return '<span class="si-w" aria-hidden="true">' + w.replace(/&/g,'&amp;').replace(/</g,'&lt;') + '</span>'; }).join(' ');
      var lines = [], top = null;
      el.querySelectorAll('.si-w').forEach(function(s){
        var t = s.offsetTop;
        if (top === null || Math.abs(t - top) > 4){ lines.push([]); top = t; }
        lines[lines.length-1].push(s.textContent);
      });
      el.innerHTML = lines.map(function(l){ return '<span class="si-line" aria-hidden="true"><span>' + l.join(' ') + '</span></span>'; }).join('');
    });
  }

  /* ---------- reveal on scroll ---------- */
  function reveal(root){
    var els = (root||document).querySelectorAll('[data-si-reveal]:not(.is-in), [data-si-mask]:not(.is-in), [data-si-lines]:not(.si-split-in), .si-hero:not(.is-in)');
    function show(e){ e.classList.add(e.hasAttribute('data-si-lines') ? 'si-split-in' : 'is-in'); }
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(show); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if (en.isIntersecting){ show(en.target); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    els.forEach(function(e){ io.observe(e); });
    var pending = Array.prototype.slice.call(els), t = null;
    function sweep(){ t = null; pending = pending.filter(function(e){ if (e.classList.contains('is-in') || e.classList.contains('si-split-in')) return false; var r = e.getBoundingClientRect(); if (r.top < window.innerHeight * 0.92 && r.bottom > 0){ show(e); return false; } return true; }); }
    (scroller === window ? window : scroller).addEventListener('scroll', function(){ if (!t) t = setTimeout(sweep, 120); }, { passive: true });
    setTimeout(sweep, 1800);
    window.addEventListener('beforeprint', function(){ els.forEach(show); });
  }

  /* ---------- parallax + header behaviour (one rAF loop) ---------- */
  var plx = [], lastY = 0, ticking = false, heroImg = null, heroEl = null;
  function collect(){
    plx = Array.prototype.slice.call(document.querySelectorAll('[data-si-parallax]'));
    heroEl = document.querySelector('.si-hero--full'); heroImg = heroEl && heroEl.querySelector('.si-hero__media');
  }
  function frame(){
    ticking = false;
    var y = getY(), vh = window.innerHeight;
    var root = document.documentElement;
    root.classList.toggle('si-header-solid', y > 40);
    if (y > 400 && y > lastY + 4) root.classList.add('si-header-hidden');
    else if (y < lastY - 4 || y < 400) root.classList.remove('si-header-hidden');
    lastY = y;
    if (reduce) return;
    if (heroImg){
      var p = Math.min(1, y / vh);
      heroImg.style.transform = 'translate3d(0,' + (p * 18) + '%,0)';
      var inner = heroEl.querySelector('.si__in'); if (inner){ inner.style.opacity = String(1 - p * 1.3); inner.style.transform = 'translate3d(0,' + (p * -60) + 'px,0)'; }
    }
    for (var i = 0; i < plx.length; i++){
      var el = plx[i], r = el.parentElement.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) continue;
      var speed = parseFloat(el.getAttribute('data-si-parallax')) || 0.12;
      var c = (r.top + r.height / 2 - vh / 2) / vh;
      el.style.transform = 'translate3d(0,' + (c * -100 * speed) + '%,0)';
    }
  }
  function onScroll(){ if (!ticking){ ticking = true; requestAnimationFrame(frame); } }

  /* ---------- request forms ---------- */
  function forms(root){
    (root||document).querySelectorAll('[data-si-request]').forEach(function(wrap){
      if (wrap.dataset.ready) return; wrap.dataset.ready = '1';
      var choices = wrap.querySelectorAll('[data-si-choice]');
      var typeInput = wrap.querySelector('[data-si-type]');
      var groups = wrap.querySelectorAll('[data-si-for]');
      var refEl = wrap.querySelector('[data-si-ref]');
      var refInput = wrap.querySelector('[data-si-ref-input]');
      var prefix = wrap.dataset.siRequest || 'SI';
      var d = new Date(), pad = function(n){ return String(n).padStart(2,'0'); };
      var ref = prefix + '-' + String(d.getFullYear()).slice(2) + pad(d.getMonth()+1) + pad(d.getDate()) + '-' + Math.random().toString(36).slice(2,6).toUpperCase();
      if (refEl) refEl.textContent = ref;
      if (refInput) refInput.value = ref;
      var keys = Array.prototype.map.call(choices, function(c){ return c.dataset.siChoice; });
      function select(key){
        choices.forEach(function(c){ c.setAttribute('aria-pressed', c.dataset.siChoice === key ? 'true' : 'false'); });
        if (typeInput) typeInput.value = key;
        groups.forEach(function(g){
          var show = g.dataset.siFor.split(' ').indexOf(key) > -1;
          g.hidden = !show;
          g.querySelectorAll('input,textarea,select').forEach(function(i){ i.disabled = !show; });
        });
        try { sessionStorage.setItem('si-choice-' + prefix, key); } catch(e){}
      }
      choices.forEach(function(c){
        c.addEventListener('click', function(){
          select(c.dataset.siChoice);
          var f = wrap.querySelector('[data-si-form]');
          if (!f) return;
          if (lenis) lenis.scrollTo(f, { offset: -100, duration: 1.2 }); else f.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        });
      });
      var start = (location.hash || '').replace('#','');
      var saved = null; try { saved = sessionStorage.getItem('si-choice-' + prefix); } catch(e){}
      select(keys.indexOf(start) > -1 ? start : (saved && keys.indexOf(saved) > -1 ? saved : keys[0]));
      window.addEventListener('hashchange', function(){ var k = (location.hash||'').replace('#',''); if (keys.indexOf(k) > -1) select(k); });
      var qp = new URLSearchParams(location.search).get('product');
      var obj = wrap.querySelector('[name="contact[Object]"]');
      if (qp && obj && !obj.value) obj.value = qp.replace(/-/g,' ').replace(/\b\w/g, function(m){ return m.toUpperCase(); });
      var form = wrap.querySelector('form');
      if (form) form.addEventListener('submit', function(){ try { sessionStorage.setItem('si-last-ref', refInput ? refInput.value : ''); } catch(e){} });
      var ok = wrap.querySelector('[data-si-success-ref]');
      if (ok){ try { ok.textContent = sessionStorage.getItem('si-last-ref') || ''; } catch(e){} }
    });
  }

  function init(root){ splitLines(root); reveal(root); forms(root); collect(); frame(); }
  function boot(){
    if (useWrapper()) scroller = pw;
    var go = function(){ if (boot.done) return; boot.done = true; init(); };
    if (document.fonts && document.fonts.ready){ document.fonts.ready.then(go); setTimeout(go, 1200); } else go();
    smooth();
    scroller.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function(){ collect(); onScroll(); });
    if (lenis) lenis.on('scroll', onScroll);
    collect(); frame();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
  if (mq.addEventListener) mq.addEventListener('change', function(e){ reduce = e.matches; });
})();
